$(function () {
  $('.btn-floating').on('mouseover', function () {
    toggleButtonClass($(this));
  });
  $('.btn-floating').on('mouseout', function () {
    toggleButtonClass($(this));
  });
  function toggleButtonClass(thisButton) {
    var windowWidth = $(window).innerWidth();
    if (windowWidth > 767) {
      if (thisButton.hasClass('open')) {
        thisButton.removeClass('open');
      } else {
        thisButton.addClass('open');
      }
    }
  }
});
